import React from "react";
import posthog from "posthog-js";

import { nodeEnv, postHogHost, postHogKey } from "./src/constants/config";
import { initPixel, trackPageView } from "./src/utils/pixel";

// @ts-ignore: allow importing SCSS for side-effects without type declarations
import "./src/styles/global.scss";

// Disable the browser's built-in scroll restoration so it cannot override
// our manual scroll-to-top on every route change.
export const onClientEntry = () => {
  if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
    window.history.scrollRestoration = "manual";
  }
  initPixel();
};

export const wrapRootElement = ({ element }: { element: React.ReactNode }) => {
  if (typeof window !== "undefined") {
    posthog.init(postHogKey, {
      api_host: postHogHost,
      debug: nodeEnv === "development",
    });
  }

  return element;
};

export const onRouteUpdate = () => {
  if (typeof window !== "undefined") {
    // requestAnimationFrame defers until after the browser's own paint + any
    // scroll-restoration the browser fires synchronously on history pushState.
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    trackPageView();
  }
};

// Tell Gatsby's scroll plugin to always start every page at the top.
export const shouldUpdateScroll = () => [0, 0];
